import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-loading-icon',
    templateUrl: './loading-icon.component.html',
    styleUrls: ['./loading-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingIconComponent {
  @Input() loading: boolean;
  @Input() size: number = 24;
}
